module.exports = __webpack_public_path__ + "img/csv.145b1e00.png";